import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {toast } from 'react-hot-toast';
import { Getunits } from '../store/slices/settings';
import { Listitems } from '../store/slices/items';
import { Getsingledetail } from '../store/slices/sale';
import {GetAdditionalTax } from "../store/slices/purchase"
import ProductSelector from '../common/ProductSelector';
import ItemRow from '../common/ItemRow';
import AddItemPopUp from '../common/AddItemPopUp';

const AddDebitNoteSec = ({ onChildDataChange,data}) => {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [state, setState] = useState({
    units: [],
    additionaltax:[],
    itemList: [],
    singleDetail: {},
    selectedProduct: null,
    quantity: 1,
    unit_id: null,
    discount: 0,
    price: 0,
    discount_type: 'Fixed',
    shippingCost:0,
    addedItems: [],
    tax: 0,
    price_tax_type: 'Excluding Tax',
    subtotal: 0,
    taxAmounts: {},
    hsn: null,
    shippingGst: 0,
    add_tax:""
  });

  const fetchUnits = useCallback(async () => {
    try {
      const data = await dispatch(Getunits()).unwrap();
      setState((prevState) => ({ ...prevState, units: data.data }));
    } catch (error) {
      console.log(error.message);
    }
  }, [dispatch]);

  const fetchItemList = useCallback(async () => {
    try {
      const data = await dispatch(Listitems({ profile_id: id })).unwrap();
      setState((prevState) => ({ ...prevState, itemList: data?.data }));
    } catch (error) {
      console.error(error.message);
    }
  }, [dispatch, id]);

  const fetchAdditionalTax = useCallback(async () => {
    try {
      const data = await dispatch(GetAdditionalTax({ profile_id: id })).unwrap();
      setState((prevState) => ({ ...prevState, additionaltax: data?.data }));
    } catch (error) {
      console.log(error.message);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchUnits();
    fetchItemList();
    fetchAdditionalTax();
  }, [fetchUnits, fetchItemList]);

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const handleOpenModal = () => {
    setIsModalOpen(true); // Open the modal
  };


  useEffect(() => {
    // Initialize addedItems from the passed data
    if (data?.items) {
      const initializedItems = data?.items?.map((item) => ({
        id:item.id,
        hsn: item.hsn,
        item_id: item.item_id,
        quantity: item.quantity,
        unit_id: item.unit_id,
        unit_name: item.unit_name, 
        price: item.price,
        price_tax_type: item.price_tax_type || "Including Tax",
        tax: item.tax || 0,
        tax_type: item.tax_type || 'GST' ,
        discount: item.discount || 0,
        discount_type: item.discount_type || "Fixed",
        discount_amount:0,
        tax_amount: item.tax_amount || 0,
        sub_total: item.sub_total || 0,
        total_amount: item.total_amount || 0,
        other_tax: item.other_tax || 0,
        other_tax_type: item.other_tax_type || "",
      }));

      // Calculate initial taxAmounts based on data?.items
      const initialTaxAmounts = initializedItems.reduce((acc, item) => {
        const taxRate = parseFloat(item.tax) || 0;
        const taxAmount = parseFloat(item.tax_amount) || 0;
        // console.log("item.tax",item.tax,"item.tax_amount",item.tax_amount)
  
        if (taxRate > 0) {
          if (acc[taxRate]) {
            acc[taxRate] += taxAmount;
          } else {
            acc[taxRate] = taxAmount;
          }
        }
        return acc;
      }, {});
      // Check if shipping cost exists and calculate shipping GST (12%)
      const shippingCost = parseFloat(state?.shippingCost) || 0;
      if (shippingCost > 0) {
        const shippingTaxRate = 0; // Fixed 12% GST for shipping
        const shippingGst = parseFloat(((shippingCost * shippingTaxRate) / 100).toFixed(2));
        setState((prevState) => ({
          ...prevState,
          shippingGst:shippingGst
        }));
        // Add shipping GST to initialTaxAmounts
        if (initialTaxAmounts[shippingTaxRate]) {
          initialTaxAmounts[shippingTaxRate] += shippingGst;
        } else {
          initialTaxAmounts[shippingTaxRate] = shippingGst;
        }
      }
      setState((prevState) => ({
        ...prevState,
        addedItems: initializedItems,
        taxAmounts: initialTaxAmounts,
        shippingCost: Number(data?.invoice?.shipping_amount) || 0,

      }));
    }else{
      setState((prevState) => ({
        ...prevState,
        addedItems: [],
        taxAmounts: [],
        shippingCost: Number(data?.invoice?.shipping_amount) || 0,

      }));
    }
  }, [data]);


  const handleProductChange = useCallback(
    async (productId) => {
      setState((prevState) => ({
        ...prevState,
        selectedProduct: productId ? productId : null,
      }));

      if (productId) {
        try {
          const data = await dispatch(Getsingledetail({ profile_id: id, item_id: productId })).unwrap();
          setState((prevState) => ({
            ...prevState,
            price:Number(data?.data?.purchase_price)?.toFixed(2),
            singleDetail: data?.data,
            unit_id: data?.data?.unit || '',
            tax: data?.data?.tax || 0,
            price_tax_type: data?.data?.purchase_price_tax_type || 'Excluding Tax',
            discount_type: data?.data?.discount_type || "Fixed",
            discount:Number(data?.data?.discount).toFixed(2)||0,
          }));
        } catch (error) {
          console.error(error.message);
        }
      } else {
        // Optionally clear product details if no product is selected
        setState((prevState) => ({
          ...prevState,
          singleDetail: {},
          selectedUnit: '',
          tax: 0,
          price_tax_type: 'Excluding Tax',
        }));
      }
    },
    [dispatch, id]
  );

  const handleInputChange = (field, value) => {
    if (field === 'shippingCost') {
      const shippingCost = parseFloat(value) || 0;
      const shippingTaxRate = 0; // Fixed rate for shipping GST
      const shippingGst = parseFloat(((shippingCost * shippingTaxRate) / 100).toFixed(2)); // Calculate GST for shipping

      // Retrieve the existing shipping GST from the state or set it to 0 if not present
      const existingShippingGst = state.shippingGst || 0;

      // Copy the existing taxAmounts state
      const updatedTaxAmounts = { ...state.taxAmounts };

      // Calculate the difference between the new shipping GST and the existing one
      const difference = shippingGst - existingShippingGst;

      // If there is an existing entry for the 12% tax, adjust it by the difference
      if (updatedTaxAmounts[shippingTaxRate]) {
        updatedTaxAmounts[shippingTaxRate] += difference;
      } else {
        updatedTaxAmounts[shippingTaxRate] = shippingGst; // Initialize shipping GST for the 12% rate if not present
      }

      // Remove the tax rate if the amount becomes zero to avoid negative values
      if (updatedTaxAmounts[shippingTaxRate] <= 0) {
        delete updatedTaxAmounts[shippingTaxRate];
      }

      // Update the state with the new shipping cost and updated taxAmounts
      setState((prevState) => ({
        ...prevState,
        shippingCost,
        shippingGst, // Store the current shipping GST for future use
        taxAmounts: updatedTaxAmounts, // Update the tax amounts including shipping GST
      }));
    } else {
      // For other fields, update state normally
      setState((prevState) => ({ ...prevState, [field]: value }));
    }
  };
   
  

  const calculateTotal = useMemo(() => {
     const { quantity, discount, discount_type, tax, price_tax_type } = state;
    const price = Number(state.price) || 0;
    const quantityTotal = price * quantity || 0;

    const taxRate = Number(tax) || 0;
    const discountValue = Number(discount) || 0;

    let taxAmount = 0;
    let discountAmount = 0;
    let totalBeforeTax = quantityTotal;
    let preTaxTotal = quantityTotal;

    if (price_tax_type === "Including Tax") {
      // Extract pre-tax amount
      taxAmount = +((quantityTotal * taxRate) / (100 + taxRate)).toFixed(2);
      preTaxTotal = quantityTotal - taxAmount;

      // Apply discount
      if (discount_type === "Fixed") {
        discountAmount = Math.min(discountValue, quantityTotal);
      } else if (discount_type === "Percentage") {
        discountAmount = (preTaxTotal * discountValue) / 100;
      }

      // Total after discount
      totalBeforeTax =
        discountValue > 0
          ? discount_type === "Fixed"
            ? quantityTotal - discountAmount
            : preTaxTotal - discountAmount
          : quantityTotal;

      // Recalculate tax based on discounted price
      if (discountValue > 0) {
        taxAmount = +((totalBeforeTax * taxRate) / (100 + taxRate)).toFixed(2);
      }
    } else {
      // Excluding tax
      if (discount_type === "Fixed") {
        discountAmount = Math.min(discountValue, totalBeforeTax);
      } else if (discount_type === "Percentage") {
        discountAmount = (totalBeforeTax * discountValue) / 100;
      }

      totalBeforeTax -= discountAmount;
      taxAmount = +(totalBeforeTax * (taxRate / 100)).toFixed(2);
    }

    // Final total logic
    const finalTotal =
      price_tax_type === "Including Tax"
        ? +totalBeforeTax.toFixed(2) // Already includes tax
        : +(totalBeforeTax + taxAmount).toFixed(2);

    return {
      finalTotal,
      discountedTotal: totalBeforeTax,
      taxAmount,
      subtotal:
        price_tax_type === "Including Tax"
          ? +(totalBeforeTax - taxAmount).toFixed(2)
          : totalBeforeTax,
      discountAmount,
    };
 }, [state]);
  

  const handleAddItem = () => {
    const {selectedProduct,quantity, price, unit_id, singleDetail, price_tax_type, tax, discount, discount_type, add_tax } = state;

    if (!selectedProduct || quantity <= 0 || price < 0) {
      toast.error('Please fill out all fields correctly.');
      return;
    }
  
    // Find the unit name
    const unitName = state.units.find((unit) => unit.id === unit_id)?.unit || '';
  
    // Calculate the total amounts, including tax, discount, and additional tax (Cess)
    const { taxAmount, subtotal, finalTotal, discountedTotal, additionalTaxAmount,discountAmount } = calculateTotal;
    // console.log("calculateTotal",calculateTotal)

    const newItem = {
      hsn: singleDetail.hsn,
      item_id: state.selectedProduct,
      quantity: state.quantity,
      unit_id: unit_id,
      unit_name: unitName,
      price: state.price,
      price_tax_type: price_tax_type,
      tax: tax,
      tax_type: 'GST',
      tax_amount: taxAmount.toFixed(2),
      other_tax: additionalTaxAmount,
      other_tax_type: add_tax,
      discount: discount,
      discount_type: discount_type,
      discount_amount:discountAmount.toFixed(2),
      sub_total: subtotal.toFixed(2),
      total_amount: finalTotal.toFixed(2), // This already includes tax and additional tax
    };
  // console.log("newItem",newItem)
    // Logic for recalculating tax and additional tax (Cess)
    const recalculatedTax = taxAmount;
  
    const additionalTaxRate = parseFloat(add_tax?.split('@')[0]) || 0; // Extracting the Cess rate from add_tax
    let additionalTaxToAdd = additionalTaxAmount || 0;
  
    if (additionalTaxRate > 0) {
      additionalTaxToAdd = +(discountedTotal * additionalTaxRate / 100).toFixed(2); // Recalculate additional tax
      // console.log("newItem2",newItem.total_amount)
      newItem.total_amount = (parseFloat(newItem.total_amount)).toFixed(2); // Add the additional tax (Cess) to the total amount
    }
  
    // Update the tax amounts in state
    const newTaxAmounts = { ...state.taxAmounts };
    
    // Handling current tax
    const currentTaxRate = parseFloat(tax);
    if (currentTaxRate) {
      if (newTaxAmounts[currentTaxRate]) {
        newTaxAmounts[currentTaxRate] += recalculatedTax;
      } else {
        newTaxAmounts[currentTaxRate] = recalculatedTax;
      }
    }
  
    // Handling additional tax (Cess)
    if (additionalTaxRate > 0) {
      if (newTaxAmounts[additionalTaxRate]) {
        newTaxAmounts[additionalTaxRate] += additionalTaxToAdd;
      } else {
        newTaxAmounts[additionalTaxRate] = additionalTaxToAdd;
      }
    }
  
    // Update the state with the new item and updated tax amounts
    setState((prevState) => ({
      ...prevState,
      addedItems: [...prevState.addedItems, newItem],
      taxAmounts: newTaxAmounts,
    }));
  
    // Clear the input fields
    clearInputs();
  };
  

  const clearInputs = () => {
    setState((prevState) => ({
      ...prevState,
      selectedProduct: null,
      quantity: 1,
      discount: 0,
      discount_type: 'Fixed',
      selectedUnit: '',
      tax: 0,
      price_tax_type: 'Excluding Tax',
      singleDetail: {},
      unit_id: '',
      add_tax:'',
      price:0
    }));
  };

  const handleItemChange = useCallback(
  (field, value, index) => {
    const updatedItems = [...state.addedItems];
    updatedItems[index] = { ...updatedItems[index], [field]: value };

    const item = updatedItems[index];
    const itemPrice = parseFloat(item.price) || 0;
    const itemQuantity = parseFloat(item.quantity) || 0;
    const itemTotal = itemPrice * itemQuantity;

    const gstRate = parseFloat(field === "tax" ? value : item.tax) || 0;
    const discountValue = parseFloat(item.discount) || 0;
    const discountType = item.discount_type;
    const priceTaxType = item.price_tax_type;

    const calculateDiscount = (total, discountValue, type) => {
      if (type === "Percentage") return (total * discountValue) / 100;
      if (type === "Fixed") return Math.min(discountValue, total);
      return 0;
    };

    const calculateTax = (total, gst, taxIncluded) => {
      if (taxIncluded) return (total * gst) / (100 + gst);
      return (total * gst) / 100;
    };

    // Calculate discounted total
    let discountAmount = calculateDiscount(itemTotal, discountValue, discountType);
    let totalAfterDiscount = itemTotal - discountAmount;

    // Calculate tax
    let taxAmount = calculateTax(totalAfterDiscount, gstRate, priceTaxType === "Including Tax");

    // Determine final total and subtotal
    let finalTotal, subtotal;
    if (priceTaxType === "Including Tax") {
      finalTotal = totalAfterDiscount; // Already includes tax
      subtotal = totalAfterDiscount - taxAmount;
    } else {
      finalTotal = totalAfterDiscount + taxAmount; // Add GST for final total
      subtotal = totalAfterDiscount; // Pre-tax subtotal
    }

    updatedItems[index].total_amount = finalTotal.toFixed(2);
    updatedItems[index].sub_total = subtotal.toFixed(2);
    updatedItems[index].tax_amount = taxAmount.toFixed(2);
    updatedItems[index].discountAmount = discountAmount.toFixed(2);

    // Recalculate total tax amounts for all GST rates
    const updatedTaxAmounts = {};
    updatedItems.forEach((itm) => {
      const itmGst = parseFloat(itm.tax) || 0;
      if (itmGst > 0) {
        const itmTotal = parseFloat(itm.price) * parseFloat(itm.quantity) || 0;
        const itmDiscount = calculateDiscount(itmTotal, parseFloat(itm.discount) || 0, itm.discount_type);
        const itmAfterDiscount = itmTotal - itmDiscount;
        const itmTax = calculateTax(itmAfterDiscount, itmGst, itm.price_tax_type === "Including Tax");
        if (updatedTaxAmounts[itmGst]) {
          updatedTaxAmounts[itmGst] += itmTax;
        } else {
          updatedTaxAmounts[itmGst] = itmTax;
        }
      }
    });

    // Round tax amounts to 2 decimals
    Object.keys(updatedTaxAmounts).forEach((key) => {
      updatedTaxAmounts[key] = parseFloat(updatedTaxAmounts[key].toFixed(2));
    });

    setState((prevState) => ({
      ...prevState,
      addedItems: updatedItems,
      taxAmounts: updatedTaxAmounts,
    }));
  },
    [state.addedItems, state.taxAmounts]
  );
 
  
  


  const handleRemoveItem = useCallback(
    (index) => {
      const updatedItems = [...state.addedItems];
      const item = updatedItems[index];
  
      // Extract item details for tax calculations
      const gst = parseFloat(item.tax) || 0;
      const price = parseFloat(item.price) || 0;
      const itemQuantity = parseFloat(item.quantity) || 0;
      let taxAmount = 0;
  
      // Calculate the additional tax (Cess) rate if applicable
      const additionalTaxRate = parseFloat(item.add_tax?.split('@')[0]) || 0;
      let additionalTaxAmount = 0;
  
      // Tax calculation based on the item's price type
      if (item.price_tax_type === 'Excluding Tax') {
        taxAmount = (price * itemQuantity * gst) / 100;
      } else if (item.price_tax_type === 'Including Tax') {
        const totalWithTax = price * itemQuantity;
        taxAmount = (totalWithTax * gst) / (100 + gst);
      }
  
      // Calculate additional tax (Cess) amount if applicable
      const itemTotalBeforeTax = item.price_tax_type === 'Including Tax' 
        ? (price * itemQuantity) / (1 + gst / 100)
        : price * itemQuantity;
      
      if (additionalTaxRate > 0) {
        additionalTaxAmount = (itemTotalBeforeTax * additionalTaxRate) / 100;
      }
  
      // Update the GST tax amounts in state
      const newTaxAmounts = { ...state.taxAmounts };
      if (newTaxAmounts[gst]) {
        newTaxAmounts[gst] -= taxAmount;
        if (newTaxAmounts[gst] < 0) {
          newTaxAmounts[gst] = 0; // Ensure no negative tax amounts
        }
      }
  
      // Update the additional tax (Cess) in state if applicable
      if (additionalTaxRate > 0) {
        if (newTaxAmounts[additionalTaxRate]) {
          newTaxAmounts[additionalTaxRate] -= additionalTaxAmount;
          if (newTaxAmounts[additionalTaxRate] < 0) {
            newTaxAmounts[additionalTaxRate] = 0; // Ensure no negative tax amounts
          }
        }
      }
  
      // Remove the item from addedItems
      updatedItems.splice(index, 1);
  
      // Update the state with the new addedItems and updated tax amounts
      setState((prevState) => ({
        ...prevState,
        addedItems: updatedItems,
        taxAmounts: newTaxAmounts,
      }));
    },
    [state.addedItems, state.taxAmounts]
  );
  

  const grandTotal = useMemo(() => {
    // Calculate total of all items and shipping
    const itemsTotal = state.addedItems.reduce((sum, item) => sum + Number(item.total_amount), 0);
    const shipping = Number(state.shippingCost) || 0;
    const shippingGst = (shipping * 0) / 100;

    // Final grand total
    return (itemsTotal + shipping + shippingGst).toFixed(2);
  }, [state.addedItems, state.shippingCost]);

  useEffect(() => {
    // Prepare the final invoice data to send back
    
    const discountAmount = state?.addedItems
      ?.reduce((sum, item) => {
        const discountAmountSubTotal = isNaN(Number(item.discount_amount)) ? 0 : Number(item.discount_amount);
        return sum + discountAmountSubTotal;
      }, 0)
      ?.toFixed(2);
    
    const gstTotal = state?.addedItems
      ?.reduce((sum, item) => {
        const itemSubTotal = isNaN(Number(item.tax_amount)) ? 0 : Number(item.tax_amount);
        return sum + itemSubTotal;
      }, 0)
      ?.toFixed(2);
    // console.log(gstTotal);
    const invoiceData = {
      sub_total: state.addedItems.reduce((sum, item) => sum + Number(item.sub_total), 0).toFixed(2),
      discount_amount:discountAmount,
      taxable_amount: gstTotal,
      shipping_amount: Number(state.shippingCost)?.toFixed(2),
      balance_amount:grandTotal,
      total_amount: grandTotal,
      total_gst: gstTotal,
      debit_note_items: state?.addedItems?.map((item) => ({
        id: item.id,
        item_id: item.item_id,
        quantity: item.quantity,
        unit_id: item.unit_id,
        unit_name: item.unit_name, // Use the unitName here
        price: item.price,
        price_tax_type: item.price_tax_type,
        tax_amount: item.tax_amount,
        tax: item.tax,
        tax_type: 'GST',
        discount: item.discount,
        discount_type: item.discount_type,
        other_tax: 0.00,
        other_tax_type: "",
        sub_total: item.sub_total,
        total_amount: item.total_amount, 
      })),
    };
    // console.log("invoiceData",invoiceData)
    onChildDataChange(invoiceData);
  }, [state.addedItems, state.shippingCost, grandTotal, onChildDataChange]);

  // console.log("addedItems",state.addedItems)
 
  return (
    <>
      {isModalOpen && <AddItemPopUp show={isModalOpen} onClose={handleCloseModal}  onCategoryAdded={fetchItemList} />}
    <div className="row my-3">
      <div className="col-md-12">
        <div className="card custom-card">
          <div className="card-body">
          <div className="d-flex justify-content-start mb-2">
                  <button className="btn ripple btn-default" onClick={handleOpenModal} >
                    Add Item
                  </button>
                </div>
            <table className="table item-table">
              <ProductSelector
                itemList={state?.itemList}
                selectedProduct={state?.selectedProduct}
                handleProductChange={handleProductChange}
                singleDetail={state?.singleDetail}
                handleInputChange={handleInputChange}
                state={state}
                calculateTotal={calculateTotal}
                handleAddItem={handleAddItem}
                isPurchase={false}
                isDiscount={false}
              />
              <tbody>
                <ItemRow
                  addedItems={state?.addedItems}
                  handleAddItem={handleAddItem}
                  handleInputChange={handleInputChange}
                  grandTotal={grandTotal}
                  state={state}
                  handleItemChange={handleItemChange}
                  handleRemoveItem={handleRemoveItem}
                  isPurchase={false}
                  isDiscount={false}
                />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default AddDebitNoteSec;